import { terms as accountTerms } from '../../design/terms';

/** "Attributed to" cell: what the queue's routing mapping points at (mockup queues.html). */
export function attributionText(attribution, topLevelName, topLevelPlural, terms = accountTerms()) {
  switch (attribution.kind) {
    case 'Community':
      return { name: attribution.name, how: `${terms.community} mapping` };
    case 'Hierarchy':
      return { name: attribution.name, how: `${topLevelName} mapping; ${terms.communityLower} from caller` };
    case 'Function':
      return { name: `All ${topLevelPlural.toLowerCase()}`, how: `Organization-wide; ${terms.communityLower} from caller` };
    default:
      return { name: 'Not mapped', how: `${terms.community} from caller` };
  }
}
